import React from "react";

const Score = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            fill={fill}
            d="M17.063 4a15.905 15.905 0 0 0-9.708 4.015l4.183 4.176a10.036 10.036 0 0 1 5.524-2.285V4Zm-6.851 9.514L6.028 9.338a15.845 15.845 0 0 0-4.027 9.69h5.917a10 10 0 0 1 2.294-5.514Zm17.87 5.515h5.917a15.844 15.844 0 0 0-4.027-9.69l-4.184 4.175a10 10 0 0 1 2.294 5.515Zm-.001 1.872a9.954 9.954 0 0 1-1.031 3.607c.38.586.758 1.173 1.133 1.761a2.787 2.787 0 0 1-.384 3.493c-.224.224-.484.409-.77.546l.974.973a.938.938 0 0 0 1.328 0A15.867 15.867 0 0 0 34 20.9h-5.92Zm-20.162 0H2a15.867 15.867 0 0 0 4.669 10.38.937.937 0 0 0 1.328 0l2.845-2.84a.936.936 0 0 0 0-1.325A10.039 10.039 0 0 1 7.918 20.9ZM28.645 8.015A15.905 15.905 0 0 0 18.938 4v5.906c2.038.186 3.95.977 5.524 2.285l4.183-4.176Zm-8.562 9.886a2.953 2.953 0 0 0-4.166 0 2.94 2.94 0 0 0 0 4.159c1.451 1.448 8.582 5.993 9.39 6.506a.939.939 0 0 0 1.436-.687.935.935 0 0 0-.141-.605c-.515-.807-5.068-7.925-6.519-9.373Z"
        />

    </svg>
);

export default Score;